import React from 'react'
import DollarIcon from '../../../../../assets/images/applicants/landing_page/dollar-sign-icon.svg'
import StarIcon from '../../../../../assets/images/applicants/landing_page/star-icon.svg'
import LightningIcon from '../../../../../assets/images/applicants/landing_page/lightning-icon.svg'
import CalendarIcon from '../../../../../assets/images/applicants/landing_page/calendar-icon.svg'
import PersonIcon from '../../../../../assets/images/applicants/landing_page/person-icon.svg'
import StoreIcon from '../../../../../assets/images/applicants/landing_page/store-icon.svg'

const DescriptionHighlights = ({ highlights, iss }: { highlights: string[]; iss?: boolean }) => {
  return (
    <div className="flex flex-col">
      <div className="my-4 flex no-wrap items-start">
        <div className="w-5 flex items-center flex-shrink-0"><img src={iss ? DollarIcon : LightningIcon} className={`mt-px ${iss ? 'w-3.5' : 'w-4'}`} alt="Dollar Sign" /></div>
        <p
          className="ml-3 lg:ml-5 text-sm"
          dangerouslySetInnerHTML={{ __html: highlights[0] }}
        />
      </div>
      <div className="my-4 flex no-wrap items-start">
        <div className="w-5 flex items-center flex-shrink-0"><img src={CalendarIcon} className="mt-px w-4" alt="Calendar" /></div>
        <p
          className="ml-3 lg:ml-5 text-sm"
          dangerouslySetInnerHTML={{ __html: highlights[1] }}
        />
      </div>
      <div className="my-4 flex no-wrap items-start">
        <div className="w-5 flex items-center flex-shrink-0"><img src={iss ? PersonIcon : DollarIcon} className="mt-px w-3.5" alt="Person" /></div>
        <p
          className="ml-3 lg:ml-5 text-sm"
          dangerouslySetInnerHTML={{ __html: highlights[2] }}
        />
      </div>
      <div className="my-4 flex no-wrap items-start">
        <div className="w-5 flex items-center flex-shrink-0"><img src={iss ? StoreIcon : StarIcon} className={`mt-px ${iss ? 'w-3.5' : 'w-5'}`} alt="Store" /></div>
        <p
          className="ml-3 lg:ml-5 text-sm"
          dangerouslySetInnerHTML={{ __html: highlights[3] }}
        />
      </div>
    </div>
  )
}

export const RoleDescription = ({
  content,
  iss
}: {
  content: {
    title: string;
    highlights: string[];
    why: {
      title: string;
      paragraphs: string[];
    };
    requirements: {
      title: string;
      paragraphs: string[];
    },
    info: {
      title: string;
      paragraphs: string[];
    }
  },
  iss?: boolean
}) => {
  return (
    <div className="role-desc lg:max-w-7xl m-auto px-7 xl:px-0 pb-14 pt-10 lg:pb-24 lg:pt-32 flex flex-col lg:flex-row items-start justify-between text-kale">
      <div className="lg:w-2/5 lg:pr-40 mb-4">
        <h2 className="font-contrast font-normal text-hxl md:text-h2xl lg:mb-14">{content.title}</h2>
        <DescriptionHighlights highlights={content.highlights} iss={iss} />
      </div>
      <div className="lg:w-3/5">
        <div className="mb-4 lg:mb-9">
          <h3 className="text-xl lg:text-2xl mb-2 lg:mb-4">{content.why.title}</h3>
          {content.why.paragraphs.map((value, i) => {
            return (
              <p
                key={i}
                className="mb-4 text-sm lg:text-base"
                dangerouslySetInnerHTML={{ __html: value }}
              />
            )
          })}
        </div>
        <div className="mb-4 lg:mb-9">
          <h3 className="text-xl lg:text-2xl mb-2 lg:mb-4">{content.requirements.title}</h3>
          <ul className="list-disc pl-4">
            {content.requirements.paragraphs.map((value, i) => {
              return (
                <li
                  key={i}
                  className="mb-2 text-sm lg:text-base"
                  dangerouslySetInnerHTML={{ __html: value }}
                />
              )
            })}
          </ul>
        </div>
        <div className="mb-4 lg:mb-9">
          <h3 className="text-xl lg:text-2xl mb-2 lg:mb-4">{content.info.title}</h3>
          {content.info.paragraphs.map((value, i) => {
            return (
              <p
                key={i}
                className="mb-4 text-sm lg:text-base"
                dangerouslySetInnerHTML={{ __html: value }}
              />
            )
          })}
        </div>
      </div>
    </div>
  )
}
